import { FC, useState } from 'react';
import useDismissedMessages from '@providers/Messages/useDismissedMessages';
import BannerHero from '@components/DesignLibrary/BannerHero';
import { m } from 'framer-motion';
import s from './DashboardOnboardingBanners.module.scss';

const DashboardOnboardingBanners: FC<{ banners: Array<
  Parameters<typeof BannerHero>[0] & { isDismissible: boolean; }
> }> = ({ banners }) => {
  const { dismissMessage, isMessageDismissed, isInitialized } = useDismissedMessages();

  const [items, setItems] = useState(banners);
  const [current, setCurrent] = useState(0);
  if (items.length === 0) {
    return null;
  }

  return (
    <ul className={s.list}>
      {items.map((item, index) => {
        const DISMISS_KEY = `${item.title.toString().toLowerCase().replace(/\s/g, '-')}`;

        if (item.isDismissible && (isMessageDismissed(DISMISS_KEY) || !isInitialized)) {
          setItems(items.filter((_, i) => i !== index));
          return null;
        }

        return (
          <m.li key={DISMISS_KEY} layout {...!item.compact && {
            style: {
              minWidth: '100%',
            },
          }}>
            <BannerHero
              {...item}
              {...item.isDismissible && {
                onDismiss: () => {
                  dismissMessage(DISMISS_KEY);
                  setItems(items.filter((_, i) => i !== index));
                  setCurrent(items.length === 2 ? 0 : (current - 1) % items.length);
                },
              }}
            />
          </m.li>
        );
      })}
    </ul>
  );
};

export default DashboardOnboardingBanners;
